"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PeakTroughTooltip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ChartTooltipUtils_1 = require("../ChartTooltipUtils");
var chartUtils_1 = require("../../chartUtils");
var ChartTooltipStyles_1 = require("../ChartTooltipStyles");
exports.PeakTroughTooltip = function (_a) {
    var data = _a.data;
    return data ? (react_1.default.createElement(ChartTooltipStyles_1.StyledContent, null,
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, "Depth"),
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, { style: {
                    color: ChartTooltipUtils_1.getTooltipValueColor(true, data.depth),
                } }, chartUtils_1.formatLinearNumbers(data.depth))),
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, "Peak"),
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, null, data.peak)),
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, "Trough"),
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, null, data.trough)),
        react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItem, null,
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemLabel, null, "Recovered"),
            react_1.default.createElement(ChartTooltipStyles_1.TooltipRowItemValue, null, data.recovered)))) : (react_1.default.createElement("div", null));
};
exports.PeakTroughTooltip.displayName = 'FOS__PeakTroughTooltip';
